/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Cell } from "react-table";
import { CostCell } from "~/components";
import { EnvironmentDetailsColumns } from "~/views/environments/EstateRecordsList";
import { generateRowData } from "~/views/estate/helpers";

type Row = ReturnType<typeof generateRowData>;

export const RelatedResourcesColumns = [
  ...EnvironmentDetailsColumns.filter(
    (column) => column.accessor !== "actualCosts"
  ),
  {
    Header: "Monthly Cost",
    accessor: "actualCosts",
    disableSortBy: true,
    width: "8rem",
    Cell: ({ row }: Cell<Row>) => {
      return (
        <CostCell
          isWaste={row.original?.isWaste}
          value={row?.original?.actualCosts}
          reason={row.original?.reason}
        />
      );
    },
  },
];
